<template id="">
  <section>
    <HeaderOfPage
    :bgSrc="'banner-4.jpeg'"
    :titleOfPage="'الفنادق'"
    :theDiscription="'ديسكربشن'"
    />
  </section>
</template>
<script type="text/javascript">
  import HeaderOfPage from '../global/HeaderOfPage'
  export default {
    name:'Hotels',
    components: {HeaderOfPage}
  }
</script>
